module.exports = __webpack_public_path__ + "static/media/ENG.4654b0e1.svg";